import { Typography } from '@material-ui/core';
import { ColorDynamic, Stack, useSnackbarStack } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import { Form, FormikProvider } from 'formik';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { useAppFormik } from 'shared/form/AppFormik';
import { FormikMaxLengthTextField } from '@superdispatch/forms';
import { useDocumentTitle } from 'shared/layout/DocumentTitle';
import { WebviewLayout } from 'shared/layout/WebviewLayout';
import {
  DriverFeedbackDTO,
  driverFeedbackSchema,
} from './data/dto/DriverFeedbackDTO';
import { useDriverFeedbackAPI } from './data/DriverFeedbackAPI';

function DriverFeedbackContainer() {
  const { addSnackbar } = useSnackbarStack();
  const { saveDriverFeedback } = useDriverFeedbackAPI();

  const formik = useAppFormik<DriverFeedbackDTO>({
    initialValues: { feedback: '' },
    validationSchema: driverFeedbackSchema,
    onSubmit: (values) => {
      return saveDriverFeedback(values.feedback);
    },
    onSubmitSuccess: () => {
      MobileAppBridge.sendDriverSubmittedFeedbackEvent();
      MobileAppBridge.closeScreen();
    },
    onSubmitFailure: (error) => {
      addSnackbar(error.message || 'Failed to submit feedback', {
        variant: 'error',
      });
    },
  });

  useDocumentTitle('Share your feedback with us!');

  return (
    <WebviewLayout backgroundColor={ColorDynamic.White}>
      <FormikProvider value={formik}>
        <Form>
          <Box padding="small" maxWidth="480px" margin="auto">
            <Stack space="small">
              <FormikMaxLengthTextField
                name="feedback"
                label={undefined}
                placeholder="Leave your feedback here"
                minRows={5}
                multiline={true}
                fullWidth={true}
                maxLength={500}
                autoFocus={true}
              />
              <Stack align="right">
                <Button
                  size="small"
                  variant="primary"
                  type="submit"
                  pending={formik.isSubmitting}
                  disabled={
                    formik.values.feedback.trim().length === 0 ||
                    formik.isSubmitting
                  }
                >
                  Submit
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Form>
      </FormikProvider>
    </WebviewLayout>
  );
}

export function DriverFeedbackPage() {
  const guid = MobileAppBridge.getDriverGuid();

  if (!guid) {
    return (
      <Box marginTop="large">
        <Typography align="center" color="textSecondary" variant="h3">
          We couldn&apos;t verify your identity
        </Typography>
      </Box>
    );
  }

  return <DriverFeedbackContainer />;
}
